import { render, staticRenderFns } from "./ManageOrganizationSsoPage.vue?vue&type=template&id=6e7743e2"
import script from "./ManageOrganizationSsoPage.vue?vue&type=script&lang=ts"
export * from "./ManageOrganizationSsoPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports